export class Activity {
    id: string;
    duration: number = 0;
    startTime: number;
    endTime: number;
    notes: string;
    name: string;
    startTimeString: string;
    endTimeString: string;
    created: number;
    createdString: string;
    modified: number;
    modifiedString: string;
    alertId: number;
    showNotes: boolean = false;
}